import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { getCookie } from '../../utils/helpers';
import { NakedLink } from '../../utils/NakedLink';


const useStyles = makeStyles(() => {
  return {
    btnCurvedRed: {
      backgroundColor: '#b31b19',
      display: 'flex',
      flexDirection: 'column',
      color: '#fff',
      maxWidth: 'fit-content',
      margin: '40px auto',
      border: 'none',
      borderRadius: '30px',
      padding: '4px 20px',
      textDecoration: 'none',
      '&:hover': {
        color: '#fff',
        textDecoration: 'none',
      },
    },
    header: {
      margin: 0,
      color: '#fff',
      fontWeight: 'lighter',
    },
    headerBold: {
      margin: 0,
      color: '#fff',
      fontWeight: 'bolder',
    },
    alignRight: {
      margin: 'auto 0px 0px auto',
      '@media (max-width: 992px)': { margin: 'auto' },
    },
    hideOnMobile: {
      display: 'block',
      '@media (max-width: 992px)': { display: 'none' },
    },
    hideOnDesktop: {
      display: 'block',
      '@media (min-width: 992px)': { display: 'none' },
    },
  };
});


const DEFAULT_CHECKOUT_URL = '/account/purchase';

function SubscribeCTAButton(props) {
  const partnerCode = getCookie('partnerSource');
  const { title, topText, alignRight, hideOnMobile, link } = props;
  const classes = useStyles();

  const getUrl = useCallback(() => {
    const baseUrl = new URL(DEFAULT_CHECKOUT_URL, window.location.origin);

    if (title === 'NAKED NEWS LIVE') {
      baseUrl.pathname = '/live';
      baseUrl.searchParams.set('showPaymentPopUp', '1');
    } else if (partnerCode?.length) {
      baseUrl.searchParams.set('promoCode', partnerCode);
    }

    return baseUrl?.pathname?.toString() + baseUrl?.search?.toString();
  }, [title, partnerCode]);
  const url = link || getUrl();


  if (topText === 'BECOME A') {
    return (
      <NakedLink
        className={
          classnames(
            classes.btnCurvedRed,
            {
              [classes.alignRight]: alignRight,
              [classes.hideOnMobile]: hideOnMobile,
              [classes.hideOnDesktop]: !hideOnMobile,
            }
          )
        } to={url}
      >
        <h4 className={classes.header}>
          {topText}
          <br />
          <b className={classes.headerBold}>{title}</b>
        </h4>
      </NakedLink>
    );
  }

  return (
    <NakedLink
      className={
        classnames(
          classes.btnCurvedRed,
          {
            [classes.alignRight]: alignRight,
            [classes.hideOnMobile]: hideOnMobile,
            [classes.hideOnDesktop]: !hideOnMobile,
          }
        )
      } to={url}
    >
      <h4 className={classes.header}>
        {topText}
        <br />
        <b className={classes.headerBold}>{title}</b>
      </h4>
    </NakedLink>
  );
}

export default SubscribeCTAButton;

SubscribeCTAButton.propTypes = {
  alignRight: PropTypes.bool,
  title: PropTypes.string,
  topText: PropTypes.string,
};

SubscribeCTAButton.defaultProps = {
  title: 'NAKED NEWS',
  topText: 'SUBSCRIBE TO',
  alignRight: false,
  hideOnMobile: false,
};
